// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutReviewAndSubmitHeaderStyles } from "@guestsupply/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, get } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

checkoutReviewAndSubmitHeaderStyles.gridItem = { width: 12 };
checkoutReviewAndSubmitHeaderStyles.headingText = {
    css: css`
        margin-bottom: 20px;
    `,
};
checkoutReviewAndSubmitHeaderStyles.buttonsWrapper = {
    css: css`
        display: flex;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    position: fixed;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    background: ${getColor("common.background")({ theme })};
                    justify-content: center;
                    z-index: ${get(theme, "zIndex.stickyFooter")};
                `,
                css`
                    margin-left: 16px;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
            ])}
    `,
};
checkoutReviewAndSubmitHeaderStyles.backButton = {
    variant: "secondary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 50%;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                ],
                "max",
            )}
    `,
};
checkoutReviewAndSubmitHeaderStyles.placeOrderButton = {
    css: css`
        flex-shrink: 0;
        margin-left: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 50%;
                    `,
                    css`
                        width: unset;
                    `,
                ],
                "min",
            )}
    `,
};
checkoutReviewAndSubmitHeaderStyles.submitForApprovalButton = {
    css: css`
        flex-shrink: 0;
        margin-left: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 50%;
                    `,
                    css`
                        width: unset;
                    `,
                ],
                "min",
            )}
    `,
};
